import { z } from "zod";

import {
  BookingAnswerSchema,
  EventQuestionSchema,
  EventQuestionType,
  EventQuestionTypeSchema,
  ProfileFieldKey,
  ProfileFieldKeySchema
} from "../../models";

// Re-export generated enums for convenience
export { EventQuestionType, ProfileFieldKey };

// Sub-question types
export const SubQuestionEntrySchema = z.object({
  label: z.string().min(1).max(256),
  required: z.boolean()
});
export type SubQuestionEntry = z.infer<typeof SubQuestionEntrySchema>;

// Each option maps to an array of sub-questions
export const SubQuestionsMapSchema = z.record(z.string(), z.array(SubQuestionEntrySchema));
export type SubQuestionsMap = z.infer<typeof SubQuestionsMapSchema>;

// DTO returned to clients (strips timestamps)
export const EventQuestionDtoSchema = EventQuestionSchema.omit({
  createdAt: true,
  updatedAt: true
}).extend({
  subQuestions: SubQuestionsMapSchema.nullable().default(null)
});
export type EventQuestionDto = z.infer<typeof EventQuestionDtoSchema>;

// DTO for org to set the full question list (PUT replaces all)
export const UpsertEventQuestionsSchema = z.object({
  questions: z.array(
    z.object({
      id: z.string().optional(),
      type: EventQuestionTypeSchema,
      profileField: ProfileFieldKeySchema.optional().nullable(),
      label: z.string().min(1).max(256),
      options: z.array(z.string()).default([]),
      required: z.boolean().default(true),
      order: z.number().int().min(0),
      subQuestions: SubQuestionsMapSchema.nullable().default(null)
    })
  )
});
export type UpsertEventQuestions = z.infer<typeof UpsertEventQuestionsSchema>;

// Single answer submitted at booking time
export const BookingAnswerInputSchema = z.object({
  questionId: z.string(),
  value: z.string().optional().nullable(),
  values: z.array(z.string()).default([]),
  subValue: z.array(z.string()).nullable().optional()
});
export type BookingAnswerInput = z.infer<typeof BookingAnswerInputSchema>;

// Answer as returned in booking detail (includes the question)
export const BookingAnswerWithQuestionSchema = BookingAnswerSchema.extend({
  question: EventQuestionDtoSchema
});
export type BookingAnswerWithQuestion = z.infer<typeof BookingAnswerWithQuestionSchema>;
